import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Button,
  Icon
} from 'semantic-ui-react'

const CardDiseaseSegmentGroupUX = (props: any) => {
    return(
      <div
        id="CardDiseaseSegmentGroupUX-div-0">
        <div
          className="ui form"
          id="CardDiseaseSegmentGroupUX-div-1"
          style={{padding:"15px", paddingBottom: 0}}>
          
          <FormGroup
            className="equal width "
            id="CardDiseaseSegmentGroupUX-FormGroup-2">
            <FormField
              id="CardDiseaseSegmentGroupUX-FormField-4">
              <label
                id="CardDiseaseSegmentGroupUX-label-5"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Segment name :" : "ชื่อ Segment :"}
              </label>
              <Input
                icon="search"
                id="CardDiseaseSegmentGroupUX-Input-6"
                onChange={props.onChangeInput}
                value={props.searchText || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            className="equal width "
            id="CardDiseaseSegmentGroupUX-FormGroup-10">
            <FormField
              id="CardDiseaseSegmentGroupUX-FormField-11">
              <Button
                color="green"
                fluid={true}
                id="CardDiseaseSegmentGroupUX-Button-13"
                onClick={props.onSearch}
                size="small">
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
            </FormField>
            <FormField
              id="CardDiseaseSegmentGroupUX-FormField-12">
              <Button
                color="blue"
                fluid={true}
                id="CardDiseaseSegmentGroupUX-Button-14"
                onClick={props.onNewSegment}
                size="small"
                style={{paddingLeft: 0, paddingRight: 0}}>
                <Icon
                  id="CardDiseaseSegmentGroupUX-Icon-15"
                  name="plus circle">
                </Icon>
                <label
                  id="CardDiseaseSegmentGroupUX-label-16">
                  {props.languageUX === "en" ? "NEW Segment" : "ส่วนใหม่"}
                </label>
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDiseaseSegmentGroupUX-div-19"
          style={{width: "100%"}}>
          {props.SegmentList}
        </div>
      </div>
    )
}

CardDiseaseSegmentGroupUX.displayName = "CardDiseaseSegmentGroupUX";
export default React.memo(CardDiseaseSegmentGroupUX)

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:06:56 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"15px\", paddingBottom: 0}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "equal width "
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-FormField-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ Segment :",
          "valueEN": "Segment name :"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-label-5"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Input",
      "parent": 4,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-Input-6"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeInput"
        },
        "value": {
          "type": "code",
          "value": "props.searchText || \"\""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "equal width "
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-FormGroup-10"
        },
        "inline": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-FormField-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 12,
      "props": {
        "color": {
          "type": "value",
          "value": "blue"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNewSegment"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: 0, paddingRight: 0}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Icon",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-Icon-15"
        },
        "name": {
          "type": "value",
          "value": "plus circle"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนใหม่",
          "valueEN": "NEW Segment"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SegmentList"
        },
        "id": {
          "type": "value",
          "value": "CardDiseaseSegmentGroupUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 19,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": true,
  "name": "CardDiseaseSegmentGroupUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 65
}

*********************************************************************************** */
